module.exports = __webpack_public_path__ + "static/media/021-snowing-1.4f05137a.svg";